<template>
  <v-container grid-list-md class="ma-0 pa-0" v-if="attendee">
    <v-layout row wrap class="py-4">
      <v-flex md3>
        <div class="text-center">
          <v-img :src="attendee.participant_image ? attendee.participant_image : null" aspect-ratio="1" v-if="attendee.participant_image">
            <action-button
              absolute
              top
              right
              small
              type="default"
              color="success"
              :text="$t('participants.verify_image')"
              @click="verifyImage(attendee.participant_id)"
              class="fab-verify-image"
              v-if="!attendee.participant_image_verified"
            />
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  absolute
                  fab
                  bottom
                  right
                  small
                  color="white"
                  class="fab-update-image"
                  :title="$t('global.upload')"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>camera_alt</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(selection, index) in uploadSelections" :key="index">
                  <v-list-item-title @click="openUpload(selection.key, attendee.participant_id)">{{ selection.label }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-img>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="cstm-v-btn darken-2 mt-3 mx-0 d-block info" v-bind="attrs" v-on="on" v-if="!attendee.participant_image"
                ><v-icon>camera_alt</v-icon> {{ $t("courses.upload_image") }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(selection, index) in uploadSelections" :key="index">
                <v-list-item-title @click="openUpload(selection.key, attendee.participant_id)">{{ selection.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-btn class="cstm-v-btn darken-2 mt-3 mx-0 d-block info"  v-if="!attendee.enrolment_id" @click="createEnrolment"
          ><v-icon>how_to_reg</v-icon> {{ $t("enrolments.create_attendee_enrolment") }}
        </v-btn>
        <div v-else>
          <v-btn class="cstm-v-btn darken-2 mt-3 mx-0 d-block info"  @click="showForm(attendee.enrolment_id, 'enrolment-basic')"
          ><v-icon>how_to_reg</v-icon> {{ $t("enrolments.edit_attendee_enrolment") }}
        </v-btn>
          <enrolmentDetails :id="Number(attendee.enrolment_id)" class="mt-3" :key="reRenderEnrDet" />
        </div>
      </v-flex>
      <v-flex md9 class="pl-4">
        <v-layout row wrap>
          <v-flex md12>
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.first_name"
                  v-model="attendee.participant.first_name"
                  :label="$t('enrolments.p_first_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.last_name"
                  v-model="attendee.participant.last_name"
                  :label="$t('enrolments.p_last_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.email"
                  v-model="attendee.participant.email"
                  :label="$t('enrolments.p_email')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.mobile"
                  v-model="attendee.participant.mobile"
                  :label="$t('enrolments.p_mobile')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.date_of_birth"
                  :value="attendee.participant.date_of_birth ? moment.utc(attendee.participant.date_of_birth).format(DATE_FORMAT) : ''"
                  :label="$t('enrolments.p_date_of_birth')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.street"
                  v-model="attendee.participant.street"
                  :label="$t('enrolments.p_address_street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.zip"
                  v-model="attendee.participant.zip"
                  :label="$t('enrolments.p_address_zip')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.city"
                  v-model="attendee.participant.city"
                  :label="$t('enrolments.p_address_city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.country"
                  :value="$dd_countries(attendee.participant.country)"
                  :label="$t('enrolments.p_address_country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader inset class="ml-0 pl-0">{{ $t("enrolments.invoice_address") }}</v-subheader>
                <v-divider class="ml-0 pl-0" width="100%"></v-divider>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="attendee.enrolment.reference">
                <v-text-field
                  name="enrolment.reference"
                  v-model="attendee.enrolment.reference"
                  :label="$t('enrolments.o_reference')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="attendee.enrolmentorg.name">
                <v-text-field
                  name="enrolments.o_name"
                  v-model="attendee.enrolmentorg.name"
                  :label="$t('enrolments.o_name')"
                  readonly
                  autocomplete="new-password"
                >
                  <template v-slot:append>
                    <v-icon @click="orgRedirect(attendee.enrolmentorg.id)" small color="grey lighten-1">fas fa-link</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="attendee.enrolmentorg.contact_first_name || attendee.enrolmentorg.contact_last_name">
                <v-text-field
                  name="enrolment.o_requestor"
                  :value="attendee.enrolmentorg.contact_first_name + ' ' + attendee.enrolmentorg.contact_last_name"
                  :label="$t('enrolments.o_requestor')"
                  readonly
                  autocomplete="new-password"
                >
                  <template v-slot:append>
                    <v-icon @click="orgRedirect(attendee.enrolmentorg.id)" small color="grey lighten-1">fas fa-link</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="attendee.organisation.invoice_street"
                  :label="$t('enrolments.o_address_street')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg1 md4 sm6 xs12>
                <v-text-field
                  v-model="attendee.organisation.invoice_zip"
                  :label="$t('enrolments.o_address_zip')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  v-model="attendee.organisation.invoice_city"
                  :label="$t('enrolments.o_address_city')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  :value="$dd_countries(attendee.organisation.invoice_country)"
                  :label="$t('enrolments.o_address_country')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="enrolment.invoice_email"
                  :value="attendee.enrolment.invoice_email"
                  :label="$t('enrolments.invoice_email')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="enrolment.comments"
                  :value="attendee.enrolment.comments"
                  :label="$t('fe.enrolment.comment')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="enable-internal-note">
            <v-textarea
              name="enrolments.internal_notes"
              :value="getComment(attendee)"
              :label="$t('enrolments.internal_notes')"
              no-resize
              @change="updateCourseComment(attendee, getComment(attendee, 'id'), $event)"
              hide-details
            ></v-textarea>
          </v-flex>
          <v-flex xs12 md6>
            <p v-if="attendee.enrolment && attendee.enrolment.created_at" class="py-0 my-0 text-left">
              {{ $t("enrolments.enrolled") + ": " + moment.utc(attendee.enrolment.created_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
            </p>
          </v-flex>
          <v-flex xs12 md6>
            <p v-if="attendee.release_certificate && attendee.certificate_released_date" class="py-0 my-0 text-right">
              {{
                $t("attendees.certificate_created_on_by", {
                  date: moment.utc(attendee.certificate_released_date).format(DATE_FORMAT + " " + TIME_FORMAT),
                  name: attendee.certificate_released_by
                })
              }}
            </p>
          </v-flex>
          <v-flex xs12 class="text-left" v-if="attendee.enrolment.participant_id && attendee.enrolment.participant_mapped">
            {{ $t("enrolments.mapped_to") }}
            <router-link :to="{ path: BACKEND_URL + '/participants/edit/' + attendee.enrolment.participant_id }">
              {{ attendee.enrolment.participant_mapped }}
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showUploadCamera" persistent :max-width="$vuetify.breakpoint.height">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <v-app-bar flat dense color="secondary">
                  <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                </v-app-bar>

                <v-card-text class="pa-2">
                  <v-flex xs12>
                    <vue-web-cam
                      ref="webcam"
                      :device-id="cameraDeviceId"
                      width="100%"
                      height="auto"
                      :resolution="{ width: 1920, height: 1080 }"
                      @cameras="cameraList"
                      @camera-change="cameraChange"
                    />
                  </v-flex>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-spacer />

                  <action-button type="cancel" @click="cancelUploadCamera" />
                  <action-button type="switchcamera" :icon="'fas fa-sync'" @click="cameraSwitch" />
                  <action-button type="upload" :icon="'camera_alt'" @click="cameraCapture" :text="$t('global.capture')" />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </div>
    </v-dialog>

    <v-dialog v-model="showUploadForm" persistent max-width="960px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <v-app-bar flat dense color="secondary">
                  <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                </v-app-bar>

                <v-card-text class="pa-4">
                  <ValidationObserver ref="participant_image">
                    <v-flex xs12>
                      <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                        <v-file-input
                          v-model="participant_image"
                          accept=".jpg,.jpeg,.png"
                          color="primary"
                          counter
                          :placeholder="$t('courses.select_image')"
                          prepend-icon="attach_file"
                          outlined
                          :show-size="1000"
                          clearable
                          :error="errors.length > 0"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:selection="{ index, text }">
                            <v-chip color="primary" dark label small>
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </ValidationProvider>
                    </v-flex>
                  </ValidationObserver>
                  <v-flex xs12>
                    <v-card
                      @drop.prevent="documentOnDropImage($event)"
                      @dragover.prevent="document_dragover_image = true"
                      @dragenter.prevent="document_dragover_image = true"
                      @dragleave.prevent="document_dragover_image = false"
                      :class="{ 'grey lighten-2': document_dragover_image }"
                    >
                      <v-card-text>
                        <v-row class="d-flex flex-column" dense align="center" justify="center">
                          <v-icon :class="[document_dragover_image ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                          <p>{{ $t("global.drop_files_here") }}</p>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />

                  <action-button type="cancel" @click="cancelUpload" />
                  <action-button @click="uploadImage()" type="upload" :disabled="!participant_image" />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </div>
    </v-dialog>

    <v-dialog v-model="showDialogForm" persistent max-width="75%">
          <div class="form-modal pa-4">
            <component
              :key="reRenderForm"
              :is="currentLoadedForm.form"
              :id="currentLoadedForm.id"
              :modal="true"
              @return_modal_form="return_modal_form"
              @return_modal_cancel_form="return_modal_cancel_form"
            ></component>
          </div>
    </v-dialog>
  </v-container>
</template>

<script>
import enrolmentDetails from "../../enrolments/partials/EnrolmentDetails.vue"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { WebCam } from "vue-web-cam"

export default {
  name: "AttendeeCourse",

  props: ["id", "course_id"],

  components: {
    enrolmentDetails,
    ValidationObserver,
    ValidationProvider,
    "vue-web-cam": WebCam,
    "enrolment-basic-form": () => import("../../enrolments/components/FormBasic"),
  },

  data() {
    return {
      attendee: null,

      uploadSelections: [
        { key: "file", label: this.$t("global.from_file") },
        { key: "camera", label: this.$t("global.from_camera") }
      ],

      participant_image: null,
      showUploadForm: false,
      showUploadCamera: false,
      cameraImg: null,
      camera: null,
      cameraDeviceId: null,
      cameraDevices: [],

      reRenderEnrDet: 0,
      reRenderForm: 0,
      currentFormId: "",
      currentForm: "",
      currentFromModule: "attendee",
      showDialogForm: false,

      document_dragover_image: false
    }
  },

  created() {
    if (this.id) {
      axios.get(this.API_URL + `attendee/${this.id}`).then((res) => {
        this.attendee = res.data.data
      })
    }
  },

  computed: {
    currentLoadedForm: function () {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    },
  },

  methods: {
    verifyImage(id) {
      let vm = this

      axios
        .post(this.API_URL + "participant/verifyImage", {
          id: id
        })
        .then((res) => {
          let participant = res.data.data
          vm.attendee.participant_image = participant.person.image_url || null
          vm.attendee.participant_image_updated_at = participant.person.image_updated_at
          vm.attendee.participant_image_verified = participant.person.image_verified

          vm.$emit("callback_attendee_updated", vm.attendee)
          vm.$awn.success(vm.$t("global.update_success"))
        })
        .catch((err) => console.log(err))
    },
    async uploadImage() {
      let vm = this
      let formData = new FormData()

      if (this.$refs.participant_image) {
        const isValid = await this.$refs.participant_image.validate()
        if (!isValid) {
          return
        }
      }

      if (!this.participant_image) {
        vm.$awn.alert(vm.$t("courses.no_image_selected"))
      } else {
        formData.append("id", this.attendee.participant_id)
        formData.append("participant_image", this.participant_image)

        axios
          .post(this.API_URL + "participant/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then((res) => {
            vm.$awn.success(vm.$t("global.update_success"))
            vm.cancelUpload()
            vm.cancelUploadCamera()

            let participant = res.data.data
            vm.attendee.participant_image = participant.person.image_url || null
            vm.attendee.participant_image_updated_at = participant.person.image_updated_at
            vm.attendee.participant_image_verified = participant.person.image_verified

            vm.$emit("callback_attendee_updated", vm.attendee)
          })
          .catch((err) => console.log(err))
      }
    },
    orgRedirect(id) {
      this.$router.push(this.BACKEND_URL + "/enrolments/organisations/view/" + id)
    },
    getComment(data, field = "comment") {
      let record = data.participant.courses.find((i) => i.tenant_attendee_id == data.id && i.tenant_course_id == this.course_id)

      if (record) {
        if (field == "id") return record.id
        if (field == "comment") return record.comment
      }

      return null
    },
    updateCourseComment(data, id, comment) {
      let vm = this
      axios
        .put(this.API_URL + "course/certreg/updatefield", {
          id: id,
          field: "comment",
          value: comment
        })
        .then((res) => {
          let record = data.participant.courses.find((i) => i.id == id)
          if (record) {
            record.comment = comment
            vm.$emit("callback_attendee_updated", vm.attendee)
          }
        })
        .catch((err) => console.log(err))
    },

    openUpload(action) {
      if (action == "camera") this.openUploadCamera()
      if (action == "file") this.openUploadForm()
    },
    openUploadCamera() {
      this.showUploadCamera = true
      this.cameraStart()
    },
    cancelUploadCamera() {
      this.showUploadCamera = false
      this.participant_image = null
      this.cameraStop()
    },
    openUploadForm() {
      this.showUploadForm = true
    },

    cancelUpload() {
      this.showUploadForm = false
      this.participant_image = null
    },

    cameraCapture() {
      let capture = this.$refs.webcam.capture()
      if (capture) {
        var file = this.$dataURLtoFile(capture, "capture.jpg")
        this.participant_image = file
        this.uploadImage()
        this.cameraStop()
      }
    },
    cameraStop() {
      if (this.$refs.webcam) {
        this.$refs.webcam.stop()
      }
    },
    cameraStart() {
      if (this.$refs.webcam) {
        this.$refs.webcam.start()
      }
    },
    cameraList(cameras) {
      this.cameraDevices = cameras

      const [first] = this.cameraDevices
      if (first) {
        this.camera = first.deviceId
        this.cameraDeviceId = first.deviceId
      }
    },
    cameraChange(deviceId) {
      this.cameraDeviceId = deviceId
      this.camera = deviceId
    },
    cameraSwitch() {
      let idx = this.cameraDevices.findIndex((x) => x.deviceId === this.cameraDeviceId)
      let devicesCount = this.cameraDevices.length

      if (devicesCount > 1) {
        idx = (idx + 1) % devicesCount
        let newCamera = this.cameraDevices[idx]
        if (newCamera) {
          this.cameraChange(newCamera.deviceId)
        }
      }
    },

    async documentOnDropImage(e) {
      this.document_dragover_image = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.participant_image = file
          }
        }
      }

      if(this.$refs.participant_image) {
        await this.$refs.participant_image.validate()
      }
    },

    showForm(id, type) {
      this.reRenderForm++
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.reRenderEnrDet++
      this.return_modal_cancel_form()
    },
    return_modal_cancel_form() {
      this.currentFormId = null
      this.currentForm = null
      this.showDialogForm = false
    },

    createEnrolment() {
      let vm = this

      axios
          .post(this.API_URL + "course/createEnrolment", {
            id: this.attendee.course_id,
            participant_ids: this.attendee.participant_id,
            site: process.env.VUE_APP_DOMAIN,
            subdomain: vm.SUBDOMAIN,
            no_enrolment: true,
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              let json = res.data

              if (json.status) {
                let ids = json.enrolment_ids.join(",")
                this.attendee.enrolment_id = ids
                this.showForm(ids, "enrolment-basic")
              } else {
                vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"))
              }
            }
          })
          .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped>
.fab-update-image {
  bottom: 5px !important;
  right: 0px !important;
}
.fab-verify-image {
  top: 5px !important;
  right: 0px !important;
}
</style>
